/**
 * Sheet 40 callout 10, second part: the provenance line's deep link (mission 10 WP18 T109; FR-019, A.5;
 * research §1.27 "The retention variants on existing screens").
 *
 * The header-parameters provenance, register 15 `provenance` with its date in `<time dateTime>`, as a link to
 * the audit log filtered to header-parameter changes: sheet 44's filters read the URL query, so the link lands
 * on exactly those events.
 */
import { Link } from 'react-router-dom'

import { date } from '@/lib/format'
import { PROVISIONAL_COPY } from '@/lib/provisional-copy'

export function HeaderAuditLink({ updatedAt }: { updatedAt: string }) {
  return (
    <Link
      to="/app/settings/audit?type=header_param_changed"
      className="text-[var(--color-link)] underline-offset-4 hover:text-[var(--color-link-hover)] hover:underline"
    >
      <time dateTime={updatedAt}>{PROVISIONAL_COPY.provenance.render({ updatedAt: date(updatedAt) })}</time>
    </Link>
  )
}
